// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background-color: white;
  padding: 0px;
  /* Other styles */




}

@media (max-width: 768px) {
  .logo {
    /* Hide desktop menu on smaller screens */
    /* display: none; */
    max-width: 250px;
    margin-top: 15px;


  }


  .header {
    min-height: 100px;
  }


}

.logo {
  max-height: 100px;

}

.logo-div {
  display: flex;
  justify-content: center;


}
.mobile-btn-lang {
  background-color: #FF3131 !important;
  color: whitesmoke;
  border: none;

  border-radius: 5px;
  margin: 2px;
  transition: all.2s ease-in-out;
  font-size: 18px;
  cursor: pointer !important;
}
.lang-button-div {
  position: absolute;
  /* background-color: #FF3131 !important; */
  color: whitesmoke;
  border: none;
  min-width: 160px;
  border-radius: 5px;
  top: 15px;
  right: 18px;
  transition: all.2s ease-in-out;
  font-size: 18px !important;
  cursor: pointer !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 75px;
}

@media (max-width: 425px) {
  .logo {
    /* Hide desktop menu on smaller screens */
    /* display: none; */
    max-width: 250px;
    margin-top: 15px;
    margin-left: -145px;

  }
  


  .header {
    min-height: 100px;
  }


}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;;;;;AAKnB;;AAEA;EACE;IACE,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;;;EAGlB;;;EAGA;IACE,iBAAiB;EACnB;;;AAGF;;AAEA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,uBAAuB;;;AAGzB;AACA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;;EAEZ,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE;IACE,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;;EAErB;;;;EAIA;IACE,iBAAiB;EACnB;;;AAGF","sourcesContent":[".header {\n  background-color: white;\n  padding: 0px;\n  /* Other styles */\n\n\n\n\n}\n\n@media (max-width: 768px) {\n  .logo {\n    /* Hide desktop menu on smaller screens */\n    /* display: none; */\n    max-width: 250px;\n    margin-top: 15px;\n\n\n  }\n\n\n  .header {\n    min-height: 100px;\n  }\n\n\n}\n\n.logo {\n  max-height: 100px;\n\n}\n\n.logo-div {\n  display: flex;\n  justify-content: center;\n\n\n}\n.mobile-btn-lang {\n  background-color: #FF3131 !important;\n  color: whitesmoke;\n  border: none;\n\n  border-radius: 5px;\n  margin: 2px;\n  transition: all.2s ease-in-out;\n  font-size: 18px;\n  cursor: pointer !important;\n}\n.lang-button-div {\n  position: absolute;\n  /* background-color: #FF3131 !important; */\n  color: whitesmoke;\n  border: none;\n  min-width: 160px;\n  border-radius: 5px;\n  top: 15px;\n  right: 18px;\n  transition: all.2s ease-in-out;\n  font-size: 18px !important;\n  cursor: pointer !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 75px;\n}\n\n@media (max-width: 425px) {\n  .logo {\n    /* Hide desktop menu on smaller screens */\n    /* display: none; */\n    max-width: 250px;\n    margin-top: 15px;\n    margin-left: -145px;\n\n  }\n  \n\n\n  .header {\n    min-height: 100px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
